/* eslint-disable array-callback-return */
/* eslint-disable no-return-await */
/* eslint-disable no-param-reassign */
import React, {
  useEffect,
  useCallback,
  useContext,
  useRef,
  useState,
} from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button as MaterialButton,
  InputLabel,
} from '@material-ui/core';
import { makeStyles } from '@mui/styles';
import { FiPlusCircle } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { AxiosResponse } from 'axios';
import { ResponsiveTooltipWrapper } from '@material-ui/lab/internal/pickers/wrappers/ResponsiveWrapper';
import { useToast } from '../../../hooks/toast';
import TabInsumos from '../TabInsumos';
import { ButtonTabs } from './styles';
import { CdProdPaiContext } from '../../../contexts/CdProdPaiContext';
import { MontagemContext } from '../../../contexts/MontagemContext';
import api from '../../../services/api';
import Input from '../../Input';
import DialogCadastroMontagem from './DialogCadastroMontagem';

interface Props {
  openInsumo: boolean;
  setOpen: (arg: boolean) => void;
}
export interface Montagem {
  cd: number;
  nm: string;
  focus: boolean;
  titulo: string;
  qtd_max: number;
  qtd_min: number;
  qtd_promo: number;
  ordem: number;
}

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    backgroundColor: '#FFF',
    height: '60vh',
  },
});

const DialogInsumos: React.FC<Props> = ({ openInsumo, setOpen }) => {
  const [addMontagem, setAddMontagem] = useState(false);
  const [currentCd, setCurrentCd] = useState<number>(-1);
  const [openCadastroMontagem, setOpenCadastroMontagem] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [montagens, setMontagens] = useState<Montagem[]>([] as any);

  const { addToast } = useToast();
  const { cd_prod_pai } = useContext(CdProdPaiContext);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const classes = useStyles();

  const changeTabs = useCallback(
    (tab: string) => {
      setMontagens(
        montagens.map((t) => {
          if (t.nm == tab) {
            t.focus = true;
            setCurrentCd(t.cd);
          } else {
            t.focus = false;
          }
          return t;
        }),
      );
    },
    [montagens],
  );
  const createMontagem = useCallback(async () => {
    setOpenCadastroMontagem(true);
  }, []);

  const getMontagem = useCallback(
    (cd) => {
      api
        .get<Montagem[]>(`montagem/montagem/${cd}`)
        .then((response) => {
          response.data.map((mont) => {
            mont.focus = false;
            return mont;
          });
          response.data.unshift({
            cd: -1,
            nm: 'GERAL',
            focus: true,
            titulo: '',
            qtd_max: 0,
            qtd_min: 0,
            qtd_promo: 0,
            ordem: 0,
          } as Montagem);
          setMontagens(response.data);
        })
        .catch((error) => {
          addToast({
            type: 'error',
            title: 'Erro',
            description: `Ops, ocorreu algum erro ao listar a montagem: ${error}`,
          });
        });
    },
    [addToast],
  );
  const handleSubmit = useCallback(() => {
    setDisabled(true);
  }, []);
  const handleDeleteMontagem = useCallback(() => {
    if (currentCd == -1) {
      addToast({
        type: 'info',
        title: 'info',
        description: `Cadastre ao menos uma montagem.`,
      });
    } else {
      api
        .delete(`/montagem/${currentCd}`)
        .then(() => {
          addToast({
            type: 'success',
            title: 'Sucesso',
            description: `A montagem foi deletada com sucesso.`,
          });
          setCurrentCd(-1);
          setMontagens(
            montagens
              .filter((mont, index) => !mont.focus)
              .map((mont, index) => {
                if (montagens.length == index + 2) {
                  mont.focus = true;
                }
                return mont;
              }),
          );
        })
        .catch((error) => {
          addToast({
            type: 'error',
            title: 'Erro',
            description: `Ocorreu um erro ao tentar deletar o insumo: '${error}'.`,
          });
        });
    }
  }, [addToast, currentCd, montagens]);
  useEffect(() => {
    if (cd_prod_pai != '') getMontagem(cd_prod_pai);
  }, [getMontagem, cd_prod_pai]);
  return (
    <>
      <Dialog
        open={openInsumo}
        fullWidth
        maxWidth="lg"
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {montagens.map((tab) => (
              <ButtonTabs
                isFocused={tab.focus}
                onClick={() => changeTabs(tab.nm)}
                type="button"
              >
                {tab.nm}
              </ButtonTabs>
            ))}
            <ButtonTabs
              isFocused
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: '4px',
                paddingRight: '8px',
                marginLeft: '8px',
                borderTopRightRadius: '8px',
                borderBottomRightRadius: '8px',
              }}
              onClick={() => createMontagem()}
              type="button"
            >
              <FiPlusCircle color="#FFF" size="16px" />
            </ButtonTabs>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className={classes.root}>
            <Box flexWrap="wrap" component="div">
              <MontagemContext.Provider
                value={{
                  montagens,
                  getMontagem,
                  setMontagens,
                  setAddMontagem,
                  addMontagem,
                  handleClose,
                  setCurrentCd,
                  currentCd,
                }}
              >
                <TabInsumos />
              </MontagemContext.Provider>
            </Box>
          </div>
        </DialogContent>
        <DialogActions>
          <MaterialButton onClick={handleDeleteMontagem} color="error">
            Excluir Montagem
          </MaterialButton>
          <MaterialButton onClick={handleClose} color="primary">
            Cancelar
          </MaterialButton>
          <MaterialButton
            type="submit"
            form="formulario"
            disabled={disabled}
            color="primary"
          >
            Confirmar
          </MaterialButton>
        </DialogActions>
      </Dialog>
      <DialogCadastroMontagem
        montagens={montagens}
        setMontagens={setMontagens}
        openCadastroMontagem={openCadastroMontagem}
        setOpenCadastroMontagem={setOpenCadastroMontagem}
        setAddMontagem={setAddMontagem}
      />
    </>
  );
};

export default DialogInsumos;
